import { ReactNode } from "react";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React TS components
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

interface Props {
  icon?: {
    color?: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark";
    component: ReactNode;
  };
  title?: string;
  description?: string | ReactNode;
  shadow?: boolean;
}

function TableTitle({ icon, title, description, shadow }: Props): JSX.Element {
  return (
    <MDBox display="flex" px={description ? 1 : 0} pt={description ? 1 : 0} mt={-2}>
      {icon?.component && (
        <MDBox
          width="3rem"
          height="3rem"
          bgColor={icon.color || "info"}
          variant="gradient"
          coloredShadow={icon.color || "info"}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          color="white"
          mr={2}
        >
          <Icon fontSize="medium">{icon?.component}</Icon>
        </MDBox>
      )}
      <MDBox>
        {title && <MDTypography variant="h5">{title}</MDTypography>}
        <MDTypography component="div" variant="button" color="text">
          {description}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

TableTitle.defaultProps = {
  title: "",
  shadow: true,
};

export default TableTitle;
